import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ValidationService } from '../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../common/utility';
import { BaseService } from '../../shared/services/base.service';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';

import { InvoiceListModel } from '../../models/payment/invoice.model';
import { DialogService } from '../../shared/services/dialog.service';
import { ConsultationProcessBarService } from './consultation-process-bar.service';

@Component({
    selector: 'add-note-popup',
    templateUrl: 'add-note-popup.component.html',
    providers: [ConsultationProcessBarService]
})

export class AddNotePopupComponent implements OnInit {
    addNotePopupForm: FormGroup;
    public isSuccess: boolean;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        public dialogRef: MdDialogRef<AddNotePopupComponent>,
        public dialogService: DialogService,
        public consultationProcessBarService: ConsultationProcessBarService,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.isSuccess = false;
        this.createForm();
        this.consultationProcessBarService.getConsultationNote(this.data['consultationId']).subscribe(
            result => {
                const data = result.json().filter(c => !c.isHistoryNote);
                let noteObj = data[0];
                let note = '';
                if (noteObj) {
                    note = noteObj['note'];
                }
                this.addNotePopupForm.controls['note'].setValue(note);
            }
        );
    }

    createForm() {
        this.addNotePopupForm = this.formBuilder.group({
            note: ['']
        });
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    onSubmit() {
        if (this.addNotePopupForm.dirty && this.addNotePopupForm.valid) {
          const param = {
                note: this.addNotePopupForm.controls['note'].value,
                noteType: this.data['activeStep']
            };
            this.consultationProcessBarService.updateConsultationNote(this.data['consultationId'], param).subscribe(
                result => {
                    this.isSuccess = true;
                    this.close();
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/consultation-progress-bar/add-note-popup.component.ts